import { ReactNode } from 'react';
import IconWithText from '../icon-with-text/IconWithText.component';
import { IconPrefixes } from '../../constants/hmds.constants';
import {
  StatusWithDueDate
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';

export type TotalsStatusProps = {
  status: StatusWithDueDate;
  children: ReactNode;
}
export const StatusPill = (props: TotalsStatusProps): JSX.Element => {

  if (props.status === StatusWithDueDate.COMPLETED_PASSED) {
    return (
      <span className="c-els-pill c-nra-status-pill c-nra-status-pill--completed-passed">
        <IconWithText
          iconName="checkmark"
          iconPrefix={IconPrefixes.HMDS}
          iconSize="3o4"
        >
          {props.children}
        </IconWithText>
      </span>
    );
  }

  if (props.status === StatusWithDueDate.COMPLETED_PASSED_PAST_DUE) {
    return (
      <span className="c-els-pill c-nra-status-pill c-nra-status-pill--completed-passed-late">
        <IconWithText
          iconName="checkmark"
          iconPrefix={IconPrefixes.HMDS}
          iconSize="3o4"
        >
          {props.children}
        </IconWithText>
      </span>
    );
  }

  if (props.status === StatusWithDueDate.COMPLETED_FAILED) {
    return (
      <span className="c-els-pill c-nra-status-pill c-nra-status-pill--completed-failed">
        {props.children}
      </span>
    );
  }

  if (props.status === StatusWithDueDate.COMPLETED_FAILED_PAST_DUE) {
    return (
      <span className="c-els-pill c-nra-status-pill c-nra-status-pill--completed-failed-late">
        {props.children}
      </span>
    );
  }

  if (props.status === StatusWithDueDate.IN_PROGRESS) {
    return (
      <span className="c-els-pill c-nra-status-pill c-nra-status-pill--in-progress">
        {props.children}
      </span>
    );
  }

  return (
    <span className="c-els-pill c-nra-status-pill">
      {props.children}
    </span>
  );
};
